const Style = {

  header: 'pb-4 mb-4',
  label: 'text-slate-400 text-sm',

}

export default Style;